import Masonry from 'masonry-layout';
import gsap from 'gsap';
import Splide from '@splidejs/splide';

export default () => {
  const gsapMediaQuery = gsap.matchMedia();

  const masonryGutterElement = document.querySelector(
    '.curated-food_dyn-item.w-dyn-item.curated-food_grid-gutter'
  );

  const masonryGutterPlaceholder = document.querySelector('.curated-food_grid-gutter-placeholder');

  const masonryGridElement = document.querySelector('.curated-food_dyn-list');
  const masonryConfig = {
    gutter: masonryGutterElement,
    percentPosition: true,
    itemSelector: '.curated-food_dyn-item',
  };

  gsapMediaQuery.add('(min-width: 767px)', () => {
    masonryGridElement.append(masonryGutterElement);

    const msnry = new Masonry(masonryGridElement, masonryConfig);

    return () => {
      msnry.destroy();
    };
  });

  gsapMediaQuery.add('(max-width: 767px)', () => {
    masonryGutterPlaceholder.before(masonryGutterElement);

    const splide = new Splide('.curated-food_splide.splide', {
      type: 'loop',
      focus: 'center',
      fixedWidth: '90%',
      gap: '1rem',
    }).mount();

    return () => {
      splide.destroy();
    };
  });
};
